"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");

/**
 * A hook that we can use to determine if a component is mounted while running async tasks
 */
var _default = function _default() {
  var initialMounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isMountedRef = (0, _react.useRef)(initialMounted); // after first render pass, useEffect will run setting isMountedRef.current to true

  (0, _react.useEffect)(function () {
    isMountedRef.current = true;
    return function () {
      // when the component unmounts, we update our ref value
      isMountedRef.current = false;
    };
  }, []);
  return {
    // export the ref
    isMounted: isMountedRef.current,
    // convenience function that will run fn only if mounted
    ifIsMounted: function ifIsMounted(fn) {
      if (isMountedRef.current) fn();
    }
  };
};
exports.default = _default;